<template>
  <div class="py-3 bg-white">
    <div class="container" v-if="active === true">
      <div v-if="questionnaire != null" class="questionnaire">
        <h1 class="question-list-title d-block pt-2">{{ questionnaire.name }}</h1>
        <p
          class="question-list-description d-block pb-2"
          v-if="questionnaire.description != null && surrounding.id !== 546"
        >{{ questionnaire.description }}</p>

        <div v-if="showSuccess">
          <div class="alert alert-success">
            <strong>Gelukt!</strong> Successvol verzonden.
          </div>
        </div>

        <!-- QUESTIONS -->
        <div
          v-for="question in questionnaire.questions.data"
          :key="question.id"
        >
          <div class="question" v-if="!question.skip">
            <!-- <span
              class="question-title d-block mt-3 mb-1"
            v-if="getQuestionType(question) === questionType.info || getQuestionType(question) === questionType.date || getQuestionType(question) === questionType.file"
            >{{ question.text }}{{ question.typeable.required ? "*" : null }}</span> -->
            <span
              class="question-title d-block mt-3 mb-1"
            >{{ question.text }}{{ question.typeable.required ? "*" : null }}</span>

            <OpenQuestion
              v-if="getQuestionType(question) === questionType.open"
              :question="question"
              @updated="handleUpdated"
              @statementUpdated="statementUpdated"
            />

            <OpenQuestion
              v-if="getQuestionType(question) === questionType.email"
              :email="true"
              :question="question"
              @updated="handleUpdated"
              @statementUpdated="statementUpdated"
            />

            <InfoQuestion
              v-if="getQuestionType(question) === questionType.info"
              :question="question"
              @updated="handleUpdated"
            />

            <NumericQuestion
              v-if="getQuestionType(question) === questionType.numeric"
              :question="question"
              @updated="handleUpdated"
              @statementUpdated="statementUpdated"
            />

            <DateQuestion
              v-if="getQuestionType(question) === questionType.date"
              :question="question"
              @updated="handleUpdated"
              @statementUpdated="statementUpdated"
            />

            <MultipleChoiceQuestion
              v-if="getQuestionType(question) === questionType.multiplechoice"
              :question="question"
              @updated="handleUpdated"
              @statementUpdated="statementUpdated"
            />

            <FileQuestion
              v-if="getQuestionType(question) === questionType.file"
              :question="question"
              @updated="handleUpdated"
              @statementUpdated="statementUpdated"
            />

          </div>
        </div>
        <div
          id="questionnaireRecaptcha"
          class="mt-3"
          :style="active ? null : 'display: none;'"
          :data-sitekey="captchaAppKey"
        ></div>
        <span class="questionnaire-error-text" v-if="$v.captchaSolved.$error">
          U bent vergeten om bovenstaand vinkje aan te klikken.
        </span>

        <p
          class="question-list-description d-block pb-2"
          v-if="questionnaire.description != null && surrounding.id === 546"
        >{{ questionnaire.description }}</p>

        <button
          class="question-list-submit my-4"
          type="button"
          :style="{ backgroundColor: surrounding.style, 'display: none': !active}"
          @click="submit"
        >Verzenden</button>
      </div>
    </div>

    <span v-if="!active" class="questionnaireNotActiveText">Niet actief.</span>

  </div>
</template>

<script>
import OpenQuestion from './questions/OpenQuestion'
import MultipleChoiceQuestion from './questions/MultipleChoiceQuestion'
import NumericQuestion from './questions/NumericQuestion'
import InfoQuestion from './questions/InfoQuestion'
import DateQuestion from './questions/DateQuestion'
import FileQuestion from './questions/FileQuestion'
import { EventBus } from './EventBus'

function isCaptchaSolved () {
  return this.captchaSolved
}

function getInitialData () {
  return {
    busy: false,
    showSuccess: false,
    active: null,
    captchaSolved: true,
    questionnaire: null,
    originalData: null,
    answers: [],
    rules: [],
    recaptchaWidgetId: -1,
    questionnaireSessionId: -1,
    ruleActions: { skip: 0, reduceAnswer: 1 },
    questionType: {
      unknown: 0,
      open: 1,
      numeric: 2,
      multiplechoice: 3,
      info: 4,
      date: 5,
      file: 6
    }
  }
}

export default {
  name: 'ec-business-questionnaire',
  components: {
    OpenQuestion,
    MultipleChoiceQuestion,
    NumericQuestion,
    InfoQuestion,
    DateQuestion,
    FileQuestion
  },

  props: {
    captchaAppKey: {
      type: String,
      default: '6LcpkywUAAAAAMZE3f5TdpGyu_D08MgRg4Eq2zDk'
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return getInitialData()
  },
  methods: {
    statementUpdated (statementContainer) {
      this.answers.forEach(answer => {
        if (statementContainer.questionId === answer.id) {
          answer.answer.statement = statementContainer.statement
        }
      })
    },
    initReCaptcha () {
      const that = this
      let timeout = setTimeout(
        function () {
          if (
            typeof grecaptcha === 'undefined' ||
            typeof grecaptcha.render === 'undefined'
          ) {
            this.initReCaptcha()
          } else {
            that.recaptchaWidgetId = grecaptcha.render(
              'questionnaireRecaptcha',
              {
                callback: this.recaptchaCallback,
                'expired-callback': this.recaptchaExpired
              }
            )
            clearTimeout(timeout)
          }
        }.bind(this),
        100
      )
    },
    recaptchaCallback (response) {
      this.$set(this, 'captchaSolved', true)
      this.$v.$touch()
    },
    recaptchaExpired (response) {
      this.$set(this, 'captchaSolved', false)
      this.$v.$touch()
    },
    getAnswersMapped () {
      return this.answers
        .map(answer => answer.answer)
        .filter(answer => {
          var skip = false

          this.questionnaire.questions.data.forEach(question => {
            if (question.id === answer.questionId) {
              skip = question.skip
            }
          })

          if (
            (Array.isArray(answer.answer) && answer.answer.length === 0) ||
            answer.answer == null ||
            ((typeof answer.answer === 'string' ||
              answer.answer instanceof String) &&
              answer.answer === '')
          ) {
            skip = true
          }

          return !skip
        })
        .sort((a, b) => {
          return a.questionId > b.questionId
        })
    },
    reset () {
      let tmp = this.originalData
      let recaptchaId = this.recaptchaWidgetId

      let initialData = getInitialData()
      for (let prop in initialData) {
        this[prop] = initialData[prop]
      }

      this.recaptchaWidgetId = recaptchaId
      this.questionnaire = tmp
      this.originalData = tmp

      this.setReactiveComps()

      this.$nextTick(function () {
        this.active = true
        var elmnt = document.getElementById('top')
        elmnt.scrollIntoView()
      })

      grecaptcha.reset(this.recaptchaWidgetId)
      this.$v.$reset()
    },
    submit () {
      EventBus.$emit('validate')
      if (this.isValid() && this.busy === false) {
        this.busy = true

        this.$http
          .post('https://beta.enjoj-test.nl/api/questionnaire/start', {
            questionnaire_id: this.questionnaire.id
          })
          .then(response => {
            let sessionId = parseInt(response.data)

            let post = {
              answered_questionnaire_id: sessionId,
              answers: this.getAnswersMapped()
            }

            this.$http
              .post('https://beta.enjoj-test.nl/api/answer', post)
              .then(response => {
                this.reset()
                this.showSuccess = true
              })
          })
      }
    },
    handleUpdated (data) {
      for (var i = 0; i < this.answers.length; i++) {
        if (this.answers[i].id === data.id) {
          this.answers[i] = data
          if (data.answer == null) {
            this.answers.splice(i, 1)
          }

          EventBus.$emit('questionAnswered', this.getOptionFilter)
          this.verifyQuestions()

          return
        }
      }

      if (data.answer != null) {
        this.answers.push(data)
      }

      for (let i = 0; i < this.questionnaire.questions.data.length; i++) {
        if (data.id === this.questionnaire.questions.data[i].id) {
          this.$set(this.questionnaire.questions.data[i], 'valid', data.valid)
        }
      }

      EventBus.$emit('questionAnswered', this.getOptionFilter)

      this.verifyQuestions()
    },
    getRuleAction (rule) {
      if (rule.action === 'SKIP') {
        return this.ruleActions.skip
      }

      return this.ruleActions.reduceAnswer
    },
    isValid () {
      this.$v.$touch()
      var valid = !this.$v.$invalid

      this.questionnaire.questions.data.forEach(question => {
        if (!question.skip && !question.valid) {
          valid = false
        }
      })

      return valid
    },
    verifyQuestions () {
      for (var i = 0; i < this.questionnaire.questions.data.length; i++) {
        this.$set(
          this.questionnaire.questions.data[i],
          'skip',
          this.mustSkip(this.questionnaire.questions.data[i])
        )

        let that = this
        this.answers.forEach(answer => {
          if (answer.id === that.questionnaire.questions.data[i].id) {
            that.$set(
              that.questionnaire.questions.data[i],
              'valid',
              answer.valid
            )
          }
        })
      }
    },
    mustSkip (question) {
      let that = this

      var skip = false
      this.questionnaire.rules.data.forEach(function (rule) {
        if (
          that.getRuleAction(rule) === that.ruleActions.skip &&
          rule.then_question_id === question.id
        ) {
          that.answers.forEach(function (questionAnswer) {
            if (questionAnswer.ranged) {
              questionAnswer.answer.answer.forEach(function (answer) {
                if (answer.answer === rule.if_answer_id) {
                  skip = true
                }
              })
            } else {
              if (questionAnswer.answer.answer === rule.if_answer_id) {
                skip = true
              }
            }
          })
        }
      })

      return skip
    },
    getQuestionType (question) {
      const friendlyName = question.friendlyName

      if (friendlyName.multipleAnswers) {
        return this.questionType.multiplechoice
      }
      if (friendlyName.ranged && !friendlyName.multipleAnswers) {
        return this.questionType.numeric
      }
      if (question.type.indexOf('InfoQuestion') !== -1) {
        return this.questionType.info
      }
      if (question.type.indexOf('DateQuestion') !== -1) {
        return this.questionType.date
      }
      if (question.type.indexOf('OpenQuestion') !== -1) {
        return this.questionType.open
      }
      if (question.type.indexOf('FileQuestion') !== -1) {
        return this.questionType.file
      }
      if (question.type.indexOf('EmailQuestion') !== -1) {
        return this.questionType.email
      }

      return this.questionType.unknown
    },
    setReactiveComps () {
      for (var i = 0; i < this.questionnaire.questions.data.length; i++) {
        this.$set(this.questionnaire.questions.data[i], 'skip', false)

        if (
          this.getQuestionType(this.questionnaire.questions.data[i]) ===
          this.questionType.info
        ) {
          this.$set(this.questionnaire.questions.data[i], 'valid', true)
        } else {
          this.$set(this.questionnaire.questions.data[i], 'valid', false)
        }
      }
    },
    getOptionFilter (question) {
      var filter = []
      let that = this
      question.options.data.forEach(function (option) {
        that.questionnaire.rules.data.forEach(function (rule) {
          if (that.getRuleAction(rule) === that.ruleActions.reduceAnswer) {
            if (rule.then_answer_id === option.id) {
              that.answers.forEach(function (questionAnswer) {
                if (questionAnswer.id === rule.if_question_id) {
                  if (questionAnswer.ranged) {
                    questionAnswer.answer.forEach(function (answer) {
                      if (answer.answer === rule.if_answer_id) {
                        filter.push(option.id)
                      }
                    })
                  } else {
                    if (questionAnswer.answer.answer === rule.if_answer_id) {
                      filter.push(option.id)
                    }
                  }
                }
              })
            }
          }
        })
      })
      return filter
    }
  },
  validations () {
    return {
      captchaSolved: {
        isCaptchaSolved
      }
    }
  },
  created () {
    this.initReCaptcha()

    let id = parseInt(this.item.itemable.id)

    this.$http
      .get('https://beta.enjoj-test.nl/api/questionnaire/' + id)
      .then(response => {
        console.log(response.data.data)
        this.active = true
        this.questionnaire = response.data.data
        this.originalData = this.questionnaire

        this.setReactiveComps()
      })
      .catch(err => {
        console.log(err)
        this.active = false
      })
  }
}
</script>
